const translations = {
  'thumbDownNoteLabel-it': 'Note (facoltativo)',
  'thumbDownNoteLabel-en': 'Note (optional)',
  'thumbDownNoteLabel-fr': 'Note (facultatif)',
  'thumbDownNoteLabel-es': 'Nota (opcional)',
  'thumbDownNoteLabel-de': 'Notiz (optional)',
  'thumbDownNoteLabel-pt': 'Nota (opcional)',
  'thumbDownNoteLabel-nl': 'Opmerking (optioneel)',
  'thumbDownNoteLabel-pl': 'Notatka (opcjonalnie)',
  'thumbDownNoteLabel-ro': 'Notă (opțional)',
  'thumbDownNoteLabel-cs': 'Poznámka (volitelné)',
  'thumbDownNoteLabel-sk': 'Poznámka (voliteľné)',
  'thumbDownNoteLabel-sl': 'Opomba (neobvezno)',
  'thumbDownNoteLabel-hr': 'Napomena (neobavezno)',
  'thumbDownNoteLabel-hu': 'Megjegyzés (opcionális)',
  'thumbDownNoteLabel-el': 'Σημείωση (προαιρετικό)',
  'thumbDownNoteLabel-sv': 'Anteckning (valfri)',
  'thumbDownNoteLabel-da': 'Note (valgfri)',
  'thumbDownNoteLabel-fi': 'Huomautus (valinnainen)',
  'thumbDownNoteLabel-no': 'Merknad (valgfri)',
  'thumbDownNoteLabel-bg': 'Бележка (по избор)',
  'thumbDownNoteLabel-et': 'Märkus (valikuline)',
  'thumbDownNoteLabel-lv': 'Piezīme (neobligāta)',
  'thumbDownNoteLabel-lt': 'Pastaba (neprivaloma)',

  'thumbDownNotePlaceholder-it':
    'Inserisci delle specifiche su come potrebbe essere migliorata la risposta',
  'thumbDownNotePlaceholder-en':
    'Enter details on how the response could be improved',
  'thumbDownNotePlaceholder-fr':
    'Entrez des détails sur la façon dont la réponse pourrait être améliorée',
  'thumbDownNotePlaceholder-es':
    'Introduce detalles sobre cómo se podría mejorar la respuesta',
  'thumbDownNotePlaceholder-de':
    'Geben Sie Details ein, wie die Antwort verbessert werden könnte',
  'thumbDownNotePlaceholder-pt':
    'Insira detalhes sobre como a resposta pode ser melhorada',

  'thumbDownNoteCancelButton-it': 'Annulla',
  'thumbDownNoteCancelButton-en': 'Cancel',
  'thumbDownNoteCancelButton-fr': 'Annuler',
  'thumbDownNoteCancelButton-es': 'Cancelar',
  'thumbDownNoteCancelButton-de': 'Abbrechen',
  'thumbDownNoteCancelButton-pt': 'Cancelar',

  'thumbDownNoteSendButton-it': 'Invia feedback',
  'thumbDownNoteSendButton-en': 'Send feedback',
  'thumbDownNoteSendButton-fr': 'Envoyer un retour',
  'thumbDownNoteSendButton-es': 'Enviar comentarios',
  'thumbDownNoteSendButton-de': 'Feedback senden',
  'thumbDownNoteSendButton-pt': 'Enviar feedback',

  'sendAMessage-it': 'Invia un messaggio',
  'sendAMessage-en': 'Send a message',
  'sendAMessage-fr': 'Envoyer un message',
  'sendAMessage-es': 'Enviar un mensaje',
  'sendAMessage-de': 'Nachricht senden',
  'sendAMessage-pt': 'Enviar uma mensagem',

  'chatSettings-it': 'Impostazioni Chat',
  'chatSettings-en': 'Chat Settings',
  'chatSettings-fr': 'Paramètres du chat',
  'chatSettings-es': 'Configuración del chat',
  'chatSettings-de': 'Chat-Einstellungen',
  'chatSettings-pt': 'Configurações do chat',

  'clearHistory-it': 'Cancella Cronologia',
  'clearHistory-en': 'Clear History',
  'clearHistory-fr': 'Effacer l’historique',
  'clearHistory-es': 'Borrar historial',
  'clearHistory-de': 'Verlauf löschen',
  'clearHistory-pt': 'Limpar histórico',

  'send-it': 'Invia',
  'send-en': 'Send',
  'send-fr': 'Envoyer',
  'send-es': 'Enviar',
  'send-de': 'Senden',
  'send-pt': 'Enviar',

  'modalClearHistoryText-it':
    "Confermi di voler cancellare l'attuale cronologia della chat?",
  'modalClearHistoryText-en':
    'Do you confirm that you want to clear the current chat history?',
  'modalClearHistoryText-fr':
    'Confirmez-vous vouloir effacer l’historique actuel du chat ?',
  'modalClearHistoryText-es':
    '¿Confirma que desea borrar el historial actual del chat?',
  'modalClearHistoryText-de':
    'Möchten Sie den aktuellen Chatverlauf wirklich löschen?',
  'modalClearHistoryText-pt':
    'Confirma que deseja limpar o histórico atual do chat?',

  'modalClearHistoryCancel-it': 'Annulla',
  'modalClearHistoryCancel-en': 'Cancel',
  'modalClearHistoryCancel-fr': 'Annuler',
  'modalClearHistoryCancel-es': 'Cancelar',
  'modalClearHistoryCancel-de': 'Abbrechen',
  'modalClearHistoryCancel-pt': 'Cancelar',

  'modalClearHistoryConfirm-it': 'Confermo',
  'modalClearHistoryConfirm-en': 'Confirm',
  'modalClearHistoryConfirm-fr': 'Confirmer',
  'modalClearHistoryConfirm-es': 'Confirmar',
  'modalClearHistoryConfirm-de': 'Bestätigen',
  'modalClearHistoryConfirm-pt': 'Confirmar',

  'contactName-it': 'Nome',
  'contactName-en': 'Name',
  'contactName-fr': 'Nom',
  'contactName-es': 'Nombre',
  'contactName-de': 'Name',
  'contactName-pt': 'Nome',

  'contactEmail-it': 'Email',
  'contactEmail-en': 'Email',
  'contactEmail-fr': 'Email',
  'contactEmail-es': 'Correo electrónico',
  'contactEmail-de': 'E-Mail',
  'contactEmail-pt': 'Email',

  'contactCompany-it': 'Azienda',
  'contactCompany-en': 'Company',
  'contactCompany-fr': 'Entreprise',
  'contactCompany-es': 'Empresa',
  'contactCompany-de': 'Unternehmen',
  'contactCompany-pt': 'Empresa',

  'contactJob-it': 'Professione',
  'contactJob-en': 'Job',
  'contactJob-fr': 'Profession',
  'contactJob-es': 'Profesión',
  'contactJob-de': 'Beruf',
  'contactJob-pt': 'Profissão',

  'contactPhone-it': 'Numero di Telefono',
  'contactPhone-en': 'Phone',
  'contactPhone-fr': 'Téléphone',
  'contactPhone-es': 'Teléfono',
  'contactPhone-de': 'Telefon',
  'contactPhone-pt': 'Telefone',

  'sendDataChat-it': 'Invia Dati',
  'sendDataChat-en': 'Send Data',
  'sendDataChat-fr': 'Envoyer les données',
  'sendDataChat-es': 'Enviar datos',
  'sendDataChat-de': 'Daten senden',
  'sendDataChat-pt': 'Enviar dados',

  'startChat-it': 'Inizia Chat',
  'startChat-en': 'Start Chat',
  'startChat-fr': 'Démarrer le chat',
  'startChat-es': 'Iniciar chat',
  'startChat-de': 'Chat starten',
  'startChat-pt': 'Iniciar chat',

  'skipChat-it': 'Salta',
  'skipChat-en': 'Skip',
  'skipChat-fr': 'Passer',
  'skipChat-es': 'Saltar',
  'skipChat-de': 'Überspringen',
  'skipChat-pt': 'Pular',

  'dataReceivedCorrectly-it': 'Dati ricevuti correttamente',
  'dataReceivedCorrectly-en': 'Data received successfully',
  'dataReceivedCorrectly-fr': 'Données reçues avec succès',
  'dataReceivedCorrectly-es': 'Datos recibidos correctamente',
  'dataReceivedCorrectly-de': 'Daten erfolgreich empfangen',
  'dataReceivedCorrectly-pt': 'Dados recebidos com sucesso',

  'dataProblemEmail-it': "C'è stato un problema con l'invio dei dati",
  'dataProblemEmail-en': 'There was a problem sending the data.',
  'dataProblemEmail-fr':
    "Un problème s'est produit lors de l'envoi des données",
  'dataProblemEmail-es': 'Hubo un problema al enviar los datos',
  'dataProblemEmail-de': 'Beim Senden der Daten ist ein Problem aufgetreten',
  'dataProblemEmail-pt': 'Ocorreu um problema ao enviar os dados',

  'thumbUpMessage-it': 'Questa risposta mi è piaciuta',
  'thumbDownMessage-it': 'Questa risposta non mi è piaciuta',

  'thumbUpMessage-en': 'I liked this response',
  'thumbDownMessage-en': 'I did not like this response',

  'thumbUpMessage-fr': 'Cette réponse m’a plu',
  'thumbDownMessage-fr': 'Cette réponse ne m’a pas plu',

  'thumbUpMessage-es': 'Me gustó esta respuesta',
  'thumbDownMessage-es': 'No me gustó esta respuesta',

  'thumbUpMessage-de': 'Diese Antwort hat mir gefallen',
  'thumbDownMessage-de': 'Diese Antwort hat mir nicht gefallen',

  'thumbUpMessage-pt': 'Gostei desta resposta',
  'thumbDownMessage-pt': 'Não gostei desta resposta',

  'thumbUpMessage-nl': 'Deze reactie vond ik goed',
  'thumbDownMessage-nl': 'Deze reactie vond ik niet goed',

  'thumbUpMessage-pl': 'Podobała mi się ta odpowiedź',
  'thumbDownMessage-pl': 'Nie podobała mi się ta odpowiedź',

  'thumbUpMessage-ro': 'Mi-a plăcut acest răspuns',
  'thumbDownMessage-ro': 'Nu mi-a plăcut acest răspuns',

  'thumbUpMessage-cs': 'Tato odpověď se mi líbila',
  'thumbDownMessage-cs': 'Tato odpověď se mi nelíbila',

  'thumbUpMessage-sk': 'Táto odpoveď sa mi páčila',
  'thumbDownMessage-sk': 'Táto odpoveď sa mi nepáčila',

  'thumbUpMessage-sl': 'Ta odgovor mi je bil všeč',
  'thumbDownMessage-sl': 'Ta odgovor mi ni bil všeč',

  'thumbUpMessage-hr': 'Ovaj odgovor mi se svidio',
  'thumbDownMessage-hr': 'Ovaj odgovor mi se nije svidio',

  'thumbUpMessage-hu': 'Tetszett ez a válasz',
  'thumbDownMessage-hu': 'Nem tetszett ez a válasz',

  'thumbUpMessage-el': 'Μου άρεσε αυτή η απάντηση',
  'thumbDownMessage-el': 'Δεν μου άρεσε αυτή η απάντηση',

  'thumbUpMessage-sv': 'Jag gillade detta svar',
  'thumbDownMessage-sv': 'Jag gillade inte detta svar',

  'thumbUpMessage-da': 'Jeg kunne godt lide dette svar',
  'thumbDownMessage-da': 'Jeg kunne ikke lide dette svar',

  'thumbUpMessage-fi': 'Pidin tästä vastauksesta',
  'thumbDownMessage-fi': 'En pitänyt tästä vastauksesta',

  'thumbUpMessage-no': 'Jeg likte dette svaret',
  'thumbDownMessage-no': 'Jeg likte ikke dette svaret',

  'thumbUpMessage-bg': 'Този отговор ми хареса',
  'thumbDownMessage-bg': 'Този отговор не ми хареса',

  'thumbUpMessage-et': 'Mulle meeldis see vastus',
  'thumbDownMessage-et': 'See vastus ei meeldinud mulle',

  'thumbUpMessage-lv': 'Man patika šī atbilde',
  'thumbDownMessage-lv': 'Man nepatika šī atbilde',

  'thumbUpMessage-lt': 'Man patiko šis atsakymas',
  'thumbDownMessage-lt': 'Man nepatiko šis atsakymas',

  'selectTypeOptionConfirm-it': 'Conferma',
  'selectTypeOptionDefault-it': 'Seleziona',

  'selectTypeOptionConfirm-en': 'Confirm',
  'selectTypeOptionDefault-en': 'Select',

  'selectTypeOptionConfirm-fr': 'Confirmer',
  'selectTypeOptionDefault-fr': 'Sélectionner',

  'selectTypeOptionConfirm-es': 'Confirmar',
  'selectTypeOptionDefault-es': 'Seleccionar',

  'selectTypeOptionConfirm-de': 'Bestätigen',
  'selectTypeOptionDefault-de': 'Auswählen',

  'selectTypeOptionConfirm-pt': 'Confirmar',
  'selectTypeOptionDefault-pt': 'Selecionar',

  'selectTypeOptionConfirm-nl': 'Bevestigen',
  'selectTypeOptionDefault-nl': 'Selecteren',

  'selectTypeOptionConfirm-pl': 'Potwierdź',
  'selectTypeOptionDefault-pl': 'Wybierz',

  'selectTypeOptionConfirm-ro': 'Confirmă',
  'selectTypeOptionDefault-ro': 'Selectează',

  'selectTypeOptionConfirm-cs': 'Potvrdit',
  'selectTypeOptionDefault-cs': 'Vybrat',

  'selectTypeOptionConfirm-sk': 'Potvrdiť',
  'selectTypeOptionDefault-sk': 'Vybrať',

  'selectTypeOptionConfirm-sl': 'Potrdi',
  'selectTypeOptionDefault-sl': 'Izberi',

  'selectTypeOptionConfirm-hr': 'Potvrdi',
  'selectTypeOptionDefault-hr': 'Odaberi',

  'selectTypeOptionConfirm-hu': 'Megerősítés',
  'selectTypeOptionDefault-hu': 'Kiválasztás',

  'selectTypeOptionConfirm-el': 'Επιβεβαίωση',
  'selectTypeOptionDefault-el': 'Επιλογή',

  'selectTypeOptionConfirm-sv': 'Bekräfta',
  'selectTypeOptionDefault-sv': 'Välj',

  'selectTypeOptionConfirm-da': 'Bekræft',
  'selectTypeOptionDefault-da': 'Vælg',

  'selectTypeOptionConfirm-fi': 'Vahvista',
  'selectTypeOptionDefault-fi': 'Valitse',

  'selectTypeOptionConfirm-no': 'Bekreft',
  'selectTypeOptionDefault-no': 'Velg',

  'selectTypeOptionConfirm-bg': 'Потвърди',
  'selectTypeOptionDefault-bg': 'Избери',

  'selectTypeOptionConfirm-et': 'Kinnita',
  'selectTypeOptionDefault-et': 'Vali',

  'selectTypeOptionConfirm-lv': 'Apstiprināt',
  'selectTypeOptionDefault-lv': 'Atlasīt',

  'selectTypeOptionConfirm-lt': 'Patvirtinti',
  'selectTypeOptionDefault-lt': 'Pasirinkti',
};

export default translations;
